import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoaurangabadcabbooking() {



  const cardData =
  {
    keyword: 'Pune to Aurangabad Cab Booking',
    heading: 'Sanavi Travels: Pune to Aurangabad Cab Booking',
    headingDescription: 'Sanavi Travels offers reliable Pune to Aurangabad Cab Booking, providing safe, comfortable, and hassle-free transportation for families, tourists, corporate travelers, and groups traveling from Pune to Aurangabad. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures spacious seating, air-conditioning, and ample luggage space for a smooth and relaxing journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular Aurangabad attractions such as Ajanta & Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga. Choose Sanavi Travels for trusted Pune to Aurangabad cab booking services, delivering comfort, safety, and a memorable outstation travel experience.',

    top: 'Top Places to Visit in Aurangabad with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "Ajanta Caves are world-famous UNESCO World Heritage rock-cut caves dating back to the 2nd century BCE. Renowned for their exquisite Buddhist paintings, sculptures, and murals, the caves depict the life of Buddha and ancient Indian culture. They are a must-visit heritage destination near Aurangabad."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves are a spectacular complex of rock-cut temples representing Buddhism, Hinduism, and Jainism. The Kailasa Temple, carved from a single rock, is the highlight and an architectural marvel. Ellora is one of India’s greatest examples of ancient engineering and artistic excellence."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Bibi Ka Maqbara is a Mughal-era monument built by Aurangzeb in memory of his wife Dilras Banu Begum. Often called the ‘Taj of the Deccan,’ it features elegant marble work, landscaped gardens, and symmetrical design, making it a popular tourist attraction."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort is a formidable hill fortress known for its strategic design, steep climb, and defensive structures. Once the capital of the Tughlaq dynasty, the fort offers panoramic views and insights into medieval military architecture."
  },
  {
    "title": "Panchakki",
    "description": "Panchakki is a historic water mill complex showcasing ancient water management systems. Built to provide water for grinding grains, it also includes gardens, fountains, and a mosque, offering a peaceful retreat within the city."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva, located near Ellora. The temple holds immense religious significance and attracts devotees throughout the year, especially during Mahashivratri."
  },
  {
    "title": "Aurangabad Caves",
    "description": "Aurangabad Caves are lesser-known Buddhist rock-cut caves located within the city. Dating back to the 6th–7th century, they feature intricate carvings, sculptures, and peaceful surroundings, ideal for history lovers."
  },
  {
    "title": "Himayat Bagh",
    "description": "Himayat Bagh is a historic Mughal garden built during Aurangzeb’s reign. Known for fruit orchards and greenery, it serves as a pleasant spot for relaxation and leisurely walks."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "description": "Siddharth Garden and Zoo is a popular family attraction featuring landscaped gardens, a zoo, and a museum. It is ideal for children and visitors looking for recreational activities."
  },
  {
    "title": "Soneri Mahal",
    "description": "Soneri Mahal is a historic palace known for its beautiful architecture and golden paintings. Today, it functions as a museum showcasing artifacts, sculptures, and remnants of Aurangabad’s rich cultural heritage."
  }
]
,




"services": [
  {
    "name": "Pune to Aurangabad Cab Booking",
    "description": "Pune to Aurangabad Cab Booking offers a comfortable, reliable, and convenient travel solution for long-distance journeys. Fully air-conditioned cabs with spacious seating, smooth suspension, and ample luggage space ensure a relaxed travel experience. Professional chauffeurs handle highway driving, traffic conditions, and route planning efficiently, ensuring timely pickups and drop-offs. Ideal for families, tourists, business travelers, and groups, this service supports one-way trips, round trips, weekend getaways, and customized travel plans between Pune and Aurangabad."
  },
  {
    "name": "Aurangabad Cab from Pune",
    "description": "Aurangabad Cab from Pune provides a dependable and hassle-free road travel option for passengers heading to Aurangabad. Well-maintained, air-conditioned vehicles combined with experienced drivers ensure safety and comfort throughout the journey. Flexible pickup and drop locations make this service suitable for home, hotel, office, or tourist destinations. Perfect for families, corporate travelers, and tourists, it focuses on punctuality, comfort, and smooth long-distance travel."
  },
  {
    "name": "AC Cab Pune to Aurangabad",
    "description": "AC Cab Pune to Aurangabad ensures a cool and relaxing journey, especially during long hours of highway travel. Fully air-conditioned cabs offer comfortable seating, clean interiors, and sufficient legroom for a pleasant ride. Skilled chauffeurs ensure safe driving and efficient route management. This service is ideal for families, solo travelers, and corporate passengers seeking comfort, safety, and reliability."
  },
  {
    "name": "Luxury Cab Aurangabad Trip",
    "description": "Luxury Cab Aurangabad Trip delivers a premium travel experience with high-end vehicles, stylish interiors, and advanced comfort features. Fully air-conditioned luxury cabs provide superior ride quality for long journeys. Professional chauffeurs offer courteous service, punctual scheduling, and smooth driving, making this option perfect for corporate executives, couples, VIP guests, and travelers who prefer a refined Pune to Aurangabad journey."
  },
  {
    "name": "Family Cab Aurangabad",
    "description": "Family Cab Aurangabad is designed to make family travel safe, comfortable, and stress-free. Spacious vehicles with air-conditioning and ample luggage space accommodate all family members comfortably. Experienced drivers prioritize smooth driving and safety, making this service ideal for family visits, holidays, religious tours, and leisure trips from Pune to Aurangabad."
  },
  {
    "name": "Outstation Cab Aurangabad",
    "description": "Outstation Cab Aurangabad offers reliable long-distance travel from Pune with well-maintained, air-conditioned vehicles. Professional chauffeurs ensure safe highway driving, timely arrivals, and flexible travel plans. Suitable for families, tourists, corporate groups, and solo travelers, this service supports both one-way and round-trip travel with comfort and convenience."
  },
  {
    "name": "Affordable Cab Aurangabad",
    "description": "Affordable Cab Aurangabad provides budget-friendly travel options without compromising on comfort or safety. Clean, air-conditioned cabs with experienced drivers ensure a smooth journey at economical pricing. Ideal for students, families, and group travelers, this service balances affordability, reliability, and convenience for Pune to Aurangabad travel."
  },
  {
    "name": "Chauffeur Driven Cab Aurangabad",
    "description": "Chauffeur Driven Cab Aurangabad offers a stress-free journey with professional drivers managing navigation, traffic, and highway conditions. Spacious, air-conditioned vehicles allow passengers to relax throughout the trip. Suitable for families, corporate travelers, and tourists, this service emphasizes safety, punctuality, and passenger comfort."
  },
  {
    "name": "Best Cab Pune to Aurangabad",
    "description": "Best Cab Pune to Aurangabad ensures a premium and dependable travel experience with well-maintained vehicles and trained chauffeurs. Fully air-conditioned cabs provide comfort for long journeys, while professional drivers ensure safe and timely travel. Ideal for business travel, family trips, and tourism, this service focuses on quality, reliability, and customer satisfaction."
  },
  {
    "name": "Pune Aurangabad Taxi",
    "description": "Pune Aurangabad Taxi is a trusted choice for regular and occasional travelers commuting between the two cities. Comfortable, air-conditioned taxis with experienced drivers offer safety, flexibility, and punctual service. This option suits families, corporate travelers, and tourists looking for a smooth and efficient road journey."
  },
  {
    "name": "Tourist Cab Aurangabad",
    "description": "Tourist Cab Aurangabad is ideal for travelers visiting Aurangabad’s famous attractions such as Ajanta and Ellora Caves, Bibi Ka Maqbara, and nearby heritage sites. Fully air-conditioned vehicles with knowledgeable chauffeurs provide a comfortable and informative travel experience. Perfect for families, groups, and tourists planning sightseeing and leisure trips."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Long Distance Cab Pune specializes in comfortable and safe intercity travel routes like Pune to Aurangabad. Air-conditioned vehicles with professional drivers ensure smooth highway journeys, timely arrivals, and relaxed travel. Suitable for family vacations, corporate travel, and extended tours, this service combines comfort, reliability, and flexibility."
  },
  {
    "name": "One Way Cab Aurangabad",
    "description": "One Way Cab Aurangabad is a cost-effective solution for travelers who need a single journey from Pune to Aurangabad. Fully air-conditioned vehicles with professional chauffeurs ensure a comfortable, safe, and timely ride. Ideal for business travelers, tourists, and families seeking flexible one-way travel options."
  },
  {
    "name": "Round Trip Cab Aurangabad",
    "description": "Round Trip Cab Aurangabad is perfect for travelers planning to return to Pune after visiting Aurangabad. Comfortable, air-conditioned vehicles with experienced chauffeurs ensure a smooth and safe round journey. Ideal for family vacations, business travel, or sightseeing tours, this service offers flexibility, convenience, and value."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking Pune allows customers to easily reserve cabs for Pune to Aurangabad travel anytime, anywhere. Users can select cab type, pickup and drop locations, travel dates, and trip preferences with instant confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure a reliable, safe, and convenient travel experience."
  }
],
"tableData": [
  ["Pune to Aurangabad Cab Booking", "Aurangabad Cab from Pune"],
  ["AC Cab Pune to Aurangabad", "Luxury Cab Aurangabad Trip"],
  ["Family Cab Aurangabad", "Outstation Cab Aurangabad"],
  ["Affordable Cab Aurangabad", "Chauffeur Driven Cab Aurangabad"],
  ["Best Cab Pune to Aurangabad", "Pune Aurangabad Taxi"],
  ["Tourist Cab Aurangabad", "Long Distance Cab Pune"],
  ["One Way Cab Aurangabad", "Round Trip Cab Aurangabad"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Aurangabad Cab Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab booking services from Pune to Aurangabad, ideal for business travel, family trips, pilgrimages, and outstation journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey from Pune to Aurangabad."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Pune to Aurangabad route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Aurangabad cab bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Cab Booking Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your Pune to Aurangabad travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Aurangabad cab booking."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab booking from Pune to Aurangabad?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab services from Pune to Aurangabad.'
  },
  {
    question: 'How can I book a Pune to Aurangabad cab?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Pune to Aurangabad travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for the Pune to Aurangabad journey.'
  },
  {
    question: 'Are drivers experienced on the Pune–Aurangabad route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Pune to Aurangabad route.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Pune and drop-off in Aurangabad.'
  },
  {
    question: 'Is the Pune to Aurangabad cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services to suit your travel schedule.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Aurangabad trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pravin Jadhav',
    feedback: 'Booked a cab from Pune to Aurangabad with Sanavi Travels. Comfortable journey, professional driver, and on-time service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Snehal Patil',
    feedback: 'Excellent experience! Clean cab, smooth ride, and very supportive customer service. Highly recommend Sanavi Travels.',
    rating: 5
  }
];


























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aurangabad Cab Booking - Sanavi Travels",
  "description": "Book Pune to Aurangabad cabs with Sanavi Travels. AC and luxury cabs for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};







  return (
    <div>
<Helmet>
  <title>
    Pune to Aurangabad Cab Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune to Aurangabad with Sanavi Travels. Perfect for family trips, outstation journeys, long-distance travel, one-way or round trips, tourist trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoaurangabadcabbooking;